import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getOpenClientEstimates } from '../services/invoices';
import './OpenEstimatesBanner.css';

export default function OpenEstimatesBanner({ clientId }) {
  const [openEstimates, setOpenEstimates] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadOpenEstimates = useCallback(async () => {
    if (!clientId) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const estimates = await getOpenClientEstimates(clientId);
      setOpenEstimates(estimates);
    } catch (error) {
      console.error('Error loading open estimates:', error);
      setOpenEstimates([]);
    } finally {
      setLoading(false);
    }
  }, [clientId]);

  useEffect(() => {
    loadOpenEstimates();
  }, [loadOpenEstimates]);

  // Listen for estimate finalized events
  useEffect(() => {
    const handleEstimateFinalized = () => {
      loadOpenEstimates();
    };
    
    window.addEventListener('estimateFinalized', handleEstimateFinalized);
    return () => {
      window.removeEventListener('estimateFinalized', handleEstimateFinalized);
    };
  }, [loadOpenEstimates]);

  const navigate = useNavigate();

  if (loading || openEstimates.length === 0) {
    return null;
  }

  const handleClick = () => {
    // Navigate to the first open estimate's invoice history tab
    const firstEstimateId = openEstimates.length > 0 ? openEstimates[0].id : null;
    navigate(`/clients/${clientId}`, { state: { activeTab: 'history', invoiceId: firstEstimateId } });
  };

  return (
    <div className="open-estimates-banner">
      <div className="banner-content">
        <span className="banner-icon">📋</span>
        <span className="banner-text">
          {openEstimates.length === 1 
            ? 'There is 1 open estimate for this client'
            : `There are ${openEstimates.length} open estimates for this client`
          }
        </span>
        <button className="banner-link" onClick={handleClick}>
          View Estimates →
        </button>
      </div>
    </div>
  );
}
